import api from "@/api";
import { find as Rfind, propEq as RpropEq } from "ramda";
import { JSConn } from "@/utilities/js-conn";

export interface WorkOrderLot {
  id: string;
  description: string;
  quantity: string;
  price: string;
  sort_order: number;
  lot_unit: string;
  lot_unit_id: string;
}

interface WorkOrderLotState {
  workOrderLots: WorkOrderLot[];
  workOrderLot: WorkOrderLot | {};
}

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    work_order_lot: {
      ...jsConn.formParams,
    },
  };
};

const itemDetails = {
  pluralName: "work_order_lots",
  singularName: "work_order_lot",
};

const state: WorkOrderLotState = {
  workOrderLots: [],
  workOrderLot: {},
};

const mutations = {
  LOAD_WORK_ORDER_LOT(state: WorkOrderLotState, payload: WorkOrderLot) {
    state.workOrderLot = payload;
  },
  LOAD_WORK_ORDER_LOTS(state: WorkOrderLotState, payload: WorkOrderLot[]) {
    state.workOrderLots = payload;
  },
};

const actions = {
  needWorkOrderLots(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
      context.commit("LOAD_WORK_ORDER_LOTS", jsConn.response);
      return Promise.resolve(jsConn);
    });
  },
  needWorkOrderLot(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api.getItem(jsConn, itemDetails).then((jsConn: JSConn) => {
      context.commit("LOAD_WORK_ORDER_LOT", jsConn.response);
      return Promise.resolve(jsConn);
    });
  },
  deleteWorkOrderLot(_context: any, jsConn: JSConn) {
    // set the api params to be correct
    // this may be called from multiple places
    // as of 2019-03-22 it is just called from the
    // workorder show page and there the entire Lot
    // is being set as the form params
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .deleteItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
  createWorkOrderLot(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .createItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        context.commit("LOAD_WORK_ORDER_LOT", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
  updateWorkOrderLot(_context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;

    return api
      .updateItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
};

const getters = {
  workOrderLot: (state: WorkOrderLotState) => state.workOrderLot,

  workOrderLots: (state: WorkOrderLotState) => state.workOrderLots,

  workOrderLotById: (state: WorkOrderLotState) => (id: string) => {
    return Rfind(lot => {
      return RpropEq("id", id, lot);
    }, state.workOrderLots);
  },
};

const workOrderLotsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default workOrderLotsModule;
